import { useEffect } from "react";
import Hotjar from '@hotjar/browser';


export const useSessionRecording2 = () => {
  useEffect(() => {
    const siteId = 5094941;
    const hotjarVersion = 6;
    Hotjar.init(siteId, hotjarVersion);
  }, []);
}
